import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import * as plan from "../redux/commonRedux/planRedux";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  plan: plan.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
  yield all([plan.saga()]);
}